






























































































































































































































































































import { Component, Vue, Watch, Mixins } from "vue-property-decorator";
import  deepcopy from 'deepcopy';
import {
  manager,
  queryList,
  saveManager,
  queryOperationMember,
  saveSubCompany,
  saveOperationService,
  isExistOperationMember
} from "@/api/operation";

import Loading from "@/mixins/loading";

@Component
export default class OperationManager extends Mixins(Loading) {
  boardTableHeader: string = "table-header-color";
  operationMemberListLength: number = 0;
  operationServiceListLength: number = 0;
  operationSubCompanyListLength: number = 0;
  tableCompanyList: any[] = [];
  tableSubCompanyList: any[] = [];

  managerDialogVisible: boolean = false;
  subCompanyDialogVisible: boolean = false;
  memberDialogVisible: boolean = false;

  managerFormInit: any = {
    manager: null,
    managerList: [],
  };
  managerForm: any = {
    manager: null,
    managerList: [],
  };
  memberList: any[] = [];


  subCompanyFormInit:any = {
    subManager: null,
    subService: null,

    subCompanyOwner: [],
    subCompanyName: "",
    subCompanyId: null,
    operationServiceList: [],
  }
  subCompanyForm: any = {
    subManager: null,
    subService: null,

    subCompanyOwner: [],
    subCompanyName: "",
    subCompanyId: null,
    operationServiceList: [],
  };
  tempMangerName: string = "";
  tempSubServiceName: string = "";
  tempSubMangerName: string = "";
  tempServiceMangerName: string = "";
  tempServiceMemberName: string = "";

  memberForm: any = {
    serviceOwner: null,
    serviceMember: null,

    serviceId: null,
    serviceName: "",
    subCompanyId: null,
    operationMembers: [],
    operationServiceOwner: [],
  };



  /**
   * 生命周期
   */
  mounted() {
    this.getData();
  }

  /**
   * methods
   */
  getData(): void {
    this.showLoading();

    manager().then((res) => {
      this.managerForm.managerList = res.data;
      this.managerFormInit.managerList = res.data;
      let temp = {
        companyName: "誉医集团",
        nicknames: "",
      };
      //数组累加字符串
      temp.nicknames = this.handleArray(res.data, "nickname");
      this.tableCompanyList = [temp];
    });

    queryList().then((res) => {
      this.tableSubCompanyList = res.data;
      this.operationSubCompanyListLength =
          res.data.length;
      this.operationServiceListLength = 0;
      this.operationMemberListLength  = 0;

      //递归遍历，增加id字段
      this.tableSubCompanyList.forEach((item: any, index: number) => {
        this.operationServiceListLength += item.serviceCount;
        this.operationMemberListLength += item.operationCount;

        item.id = item.subCompanyId;
        item.index = index;
        if (item.operationServiceList && item.operationServiceList.length) {
          item.operationServiceList.forEach((service: any) => {
            service.id = service.serviceId;
            service.subCompanyId = item.subCompanyId;
            service.operationServiceOwner = service.operationAdminOwner;
          });
        }else{
          item.operationServiceList = [];
        }
      });
    }).finally(() => {
        this.hideLoading();
      });;
  }

  handleClose(item:any,obj:any,isOperation?:any){
    if(isOperation){
      isExistOperationMember({
        operationMemberId:item.memberId,
      }).then((res)=>{
        if(res.data){
          this.$message.error("运营管下面有客户不能删除，只有客户关系转移绑定后才能删除！");
          return;
        }else{
            if(obj.indexOf(item)>-1){
              obj.splice(obj.indexOf(item),1);
              this.$forceUpdate();
            }
        }
      });
    }else{
      if(obj.indexOf(item)>-1){
        obj.splice(obj.indexOf(item),1);
        this.$forceUpdate();
      }
    }

  }

  getManager(queryString: string) {
    queryOperationMember({
      isOperationMember:false,
      param: queryString,
    }).then((res) => {
      this.memberList = res.data;
    });
  }

  addManagerList() {
   this.managerForm.manager &&  this.managerForm.managerList.push(this.managerForm.manager);
  }

  cancelUpdateManager(): void {
    this.managerDialogVisible = false;
  }

  confirmUpdateManager() {
    let temp = this.managerForm.managerList;
    saveManager(temp).then(() => {
      this.managerDialogVisible = false;
      this.getData();
    });
  }


  addSubManagerList() {
    this.subCompanyForm.subManager && this.subCompanyForm.subCompanyOwner.push(this.subCompanyForm.subManager);
  }

  changeSubService(item: any): void {
    this.subCompanyForm.subService = {
      serviceName: item,
    };
    this.tempSubServiceName = item;
  }

  addSubServiceList() {
    this.subCompanyForm.subService && this.subCompanyForm.subService.serviceName && this.subCompanyForm.operationServiceList.push(
      this.subCompanyForm.subService
    );
  }
  subCompanyCancelUpdate(): void {
    this.subCompanyDialogVisible = false;
  }

  subCompanyConfirmUpdate() {
    let temp = {
      subCompanyOwner: this.subCompanyForm.subCompanyOwner,
      subCompanyName: this.subCompanyForm.subCompanyName,
      subCompanyId: null,
      operationServiceBase: this.subCompanyForm.operationServiceList,
    };
    if (this.subCompanyForm.subCompanyId) {
      temp.subCompanyId = this.subCompanyForm.subCompanyId;
    }
    saveSubCompany(temp).then(() => {
      this.subCompanyDialogVisible = false;
      this.getData();
    });
  }


  

  addServiceManagerList() {
    this.memberForm.serviceOwner && this.memberForm.operationServiceOwner.push(this.memberForm.serviceOwner);
    this.$forceUpdate();
  }

 
  addServiceMemberList() {
    this.memberForm.serviceMember && this.memberForm.operationMembers.push(this.memberForm.serviceMember);
  }

  memberCancelUpdate(): void {
    this.memberDialogVisible = false;
  }

  memberConfirmUpdate() {
    let temp = {
      subCompanyId: this.memberForm.subCompanyId,
      serviceId: this.memberForm.serviceId,
      serviceName: this.memberForm.serviceName,
      operationMembers: this.memberForm.operationMembers,
      operationServiceOwner: this.memberForm.operationServiceOwner,
    };
    saveOperationService(temp).then(() => {
      this.memberDialogVisible = false;
      this.getData();
    });
  }

  //处理数组中的字段，拼接成字符串
  handleArray(arr: any[], key: string): string {
    let str = "";
    //数组长度为1时，不需要拼接,返回第一个元素
    //数组的最后一个元素不需要拼接
    if (arr.length == 1) {
      return arr[0][key];
    }else if(arr.length>1){
      for (let i = 0; i < arr.length - 1; i++) {
        str += arr[i][key] + ",";
      }
      str += arr[arr.length - 1][key];
    }
    return str;
  }

  editManager() {
    this.managerForm = deepcopy(this.managerFormInit);
    this.managerDialogVisible = true;
  }

  addSubCompany(){
    this.subCompanyDialogVisible = true;
    this.subCompanyForm = deepcopy(this.subCompanyFormInit);
    this.tempSubServiceName = '';
  }

  changeSubCompany(subCompany: any): void {
    this.subCompanyDialogVisible = true;
    this.subCompanyForm = deepcopy(subCompany);
    this.tempSubServiceName = '';
  }

  changeMemberDialogVisible(service: any): void {
    if(!service.operationServiceOwner){
      service.operationServiceOwner = []
    }
    this.memberForm = deepcopy(service);
    this.memberDialogVisible = true;
  }



  editAny(data: any) {
    if(data.row.subCompanyName){
      this.changeSubCompany(data.row);
    }else{
      this.changeMemberDialogVisible(data.row);
    }
  }
}
